import { useState, useRef } from "react";
import styles from "./ScrollNav.module.scss";

import ScrollIndicator from "components/ui/ScrollIndicator/ScrollIndicator";
import SideScrollButtons from "../../buttons/SideScrollButtons/SideScrollButtons";

const ScrollNav = ({
  anchorTags,
  justify,
  style,
  containerStyles,
  onClick,
}) => {
  const [selectedItem, setSelectedItem] = useState(0);

  const containerRef = useRef();

  const menu = anchorTags.map((tag, index) => {
    if (tag.active !== false) {
      return (
        <a
          href={`#${tag.tag}`}
          className={`${styles.scrollNavItem} ${
            selectedItem === index && styles.selected
          }`}
          key={index}
          onClick={(event) => {
            setSelectedItem(index);
            onClick ? onClick(event, tag) : "";
          }}
        >
          {tag.text}
        </a>
      );
    }
  });
  return (
    <div className={`${styles.scrollNavContainer}`}>
      <nav
        style={containerStyles}
        className={`${styles.scrollNav} ${
          style && styles[style]
        } wn-scroll-container ${
          justify
            ? styles[
                `justify${
                  justify[0].toUpperCase() + justify.slice(1, justify.length)
                }`
              ]
            : ""
        }`}
        ref={containerRef}
      >
        {menu}
        <div className={`${styles.sideScrollButtonsContainer}`}>
          <SideScrollButtons
            cardRowRef={containerRef}
            isCardRow={false}
            type="sides"
          />
        </div>
      </nav>

      <ScrollIndicator
        scrollContainerRef={containerRef}
        containerStyles={{ width: "20%", maxWidth: "80px" }}
      />
    </div>
  );
};

export default ScrollNav;
